import { AuthorizedSenderEmailAddressDTO } from "../DTO/authorizedSenderEmailAddressDTO";
import { BasicRequest } from "./basicRequest";

export class CreateAuthorizedSenderEmailAddressRequest extends BasicRequest{
    
    public authorizedSenderEmailAddress! : AuthorizedSenderEmailAddressDTO;

    constructor(){
        super();
    } 
}